import React, { ReactNode } from 'react'
import Styled from './styles'

interface IProps {
  className?: string
  isHidden?: boolean
  children?: ReactNode
}

export const Dropdown: React.FC<IProps> = ({ className, isHidden, children }) => {
  if (isHidden) return null

  return <Styled className={ className || '' } >{ children }</Styled>
}
